var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:`eg-tag-size--${_vm.size}`,style:({ cursor: _vm.$listeners.click ? 'pointer' : 'default' }),attrs:{"label":_vm.tooltip},on:{"click":_vm.onClickHandler}},[_vm._t("default"),_c('span',{staticClass:"tag-title text-truncate"},[_vm._v(_vm._s(_vm.label))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }